import Box from "./BoxComponent";
import InputField from "./TextInputComponent";
import UserSvg from "../assets/icons/user.svg";
import PhoneSvg from "../assets/icons/gmail.svg";
import keySvg from "../assets/icons/key.svg";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { useState } from "react";
import CustomButton from "./CustomButton";
import lootka from "../assets/images/logo-removebg-preview.png";
import { ReactComponent as Close } from "../assets/icons/x-circle.svg";
import { signupUser } from "../services/authService";
import { toast } from "react-toastify";
import RegisterChoise from "./RegisterChoise";

const signupSchema = z.object({
  username: z
    .string({ required_error: "نام کاربری برای ثبت نام لازمه!" })
    .min(3, { message: "نام کاربری باید حداقل 3 کاراکتر باشد" })
    .max(30, { message: "نام کاربری باید حداکثر 30 کاراکتر باشد" })
    .regex(/^[a-zA-Z0-9]+$/, {
      message: "نام کاربری فقط باید شامل حروف بزرگ و کوچک و اعداد باشد",
    })
    .refine((s) => !s.includes(" "), {
      message: "نام کاربری نباید شامل فاصله باشد",
    }),
  mobile: z
    .string({ required_error: "شماره تلفن برای ثبت نام لازمه!" })
    .max(15, { message: "شماره تلفن نباید بیشتر از 15 رقم باشد" })
    .regex(/^(\+98|0)?9\d{9}$/, { message: "شماره تلفن معتبر نیست" }),
  password_hash: z
    .string({ required_error: "رمز عبور برای ثبت نام لازمه!" })
    .min(8, { message: "رمز عبور باید حداقل 8 کاراکتر باشد" })
    .max(50, { message: "رمز عبور باید حداکثر 50 کاراکتر باشد" })
    .regex(/[A-Z]/, { message: "رمز عبور باید شامل حداقل یک حرف بزرگ باشد" })
    .regex(/[a-z]/, { message: "رمز عبور باید شامل حداقل یک حرف کوچک باشد" })
    .regex(/[0-9]/, { message: "رمز عبور باید شامل حداقل یک عدد باشد" }),
});

type SignupFormData = z.infer<typeof signupSchema>;

interface SignUpProps {
  onClose?: () => void;
  switchToLogin?: () => void;
}

const SignUp = ({ onClose, switchToLogin }: SignUpProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<SignupFormData>({
    resolver: zodResolver(signupSchema),
  });

  const onSubmit = async (data: SignupFormData) => {
    try {
      setIsLoading(true);

      await signupUser({
        username: data.username,
        mobile: data.mobile,
        password_hash: data.password_hash,
      });

      toast.success("ثبت نام با موفقیت انجام شد", {
        className: "toast",
      });

      setTimeout(() => {
        if (switchToLogin) switchToLogin();
      }, 1500);
    } catch (error: any) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "خطایی رخ داد!";
      toast.error(message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box heightClass="h-[500px] relative p-2">
      {/* Close Button */}
      <button
        onClick={onClose}
        className="absolute top-6 left-6 z-50 text-gray-700 hover:text-gray-500 text-2xl"
        aria-label="Close"
      >
        <Close />
      </button>

      <img src={lootka} alt="lootka" className="absolute top-2 w-[50%]" />

      <RegisterChoise switchToLogin={switchToLogin} active="signup" />

      <form
        onSubmit={handleSubmit(onSubmit)}
        className="mt-[24%] flex flex-col items-center"
      >
        <InputField
          type="text"
          placeholder="نام کاربری"
          name="username"
          iconsrc={UserSvg}
          error={errors.username?.message}
          register={register}
        />

        <InputField
          type="tel"
          placeholder="شماره موبایل"
          name="mobile"
          iconsrc={PhoneSvg}
          error={errors.mobile?.message}
          register={register}
        />

        <InputField
          type="password"
          placeholder="رمز عبور"
          name="password_hash"
          iconsrc={keySvg}
          error={errors.password_hash?.message}
          register={register}
        />

        <CustomButton
          text={isLoading ? "در حال ثبت نام..." : "ثبت نام"}
          className="mt-[5%] bg-[#4D93A5] text-white w-full rounded-lg justify-center text-sm font-myYekanMedium disabled:opacity-50"
          handleOnClick={() => {}}
        />
      </form>
    </Box>
  );
};

export default SignUp;